/**
 * The overlay stack. Every open popover, dialog or menu registers here while
 * it is open; only the topmost one answers Escape, so a popover inside a
 * dialog closes alone and the dialog stays.
 */
import { useEffect, useId } from 'react'

const stack: string[] = []

export function useOverlay(open: boolean, onEscape: () => void): string {
  const id = useId()
  useEffect(() => {
    if (!open) return
    stack.push(id)
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.isComposing) return
      if (stack[stack.length - 1] !== id) return
      event.stopPropagation()
      onEscape()
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('keydown', onKey)
      const at = stack.lastIndexOf(id)
      if (at >= 0) stack.splice(at, 1)
    }
  }, [open, id, onEscape])
  return id
}
